import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@repo/ui-primitives/utils';
import { Link } from '@tanstack/react-router';
import { application_remotes_path, project_application_list_path } from '@repo/routes';
import { Cloud, FolderGit, GitBranch } from 'lucide-react';
function getProjectParams(param) {
    let { params } = param;
    return {
        organization: {
            name: params.organization
        },
        project: {
            name: params.project
        }
    };
}
function getAppParams(param) {
    let { params } = param;
    return {
        organization: {
            name: params.organization
        },
        project: {
            name: params.project
        },
        application: {
            name: params.application
        }
    };
}
function ItemCounter(param) {
    let { counters, hostPlatform, params } = param;
    const itemClass = 'flex items-center gap-1 text-sm';
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            !!counters.applications && /*#__PURE__*/ _jsxs(Link, {
                className: itemClass,
                to: project_application_list_path(getProjectParams({
                    params
                })),
                children: [
                    /*#__PURE__*/ _jsx(FolderGit, {
                        className: "h-4 w-4",
                        style: {
                            stroke: '#27584D'
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: counters.applications
                    })
                ]
            }),
            !!counters.remotes && /*#__PURE__*/ _jsxs(Link, {
                className: cn(itemClass, !params.application && 'cursor-not-allowed opacity-50'),
                to: application_remotes_path(getAppParams({
                    params
                })),
                disabled: !params.application,
                children: [
                    /*#__PURE__*/ _jsx(GitBranch, {
                        className: "h-4 w-4",
                        style: {
                            stroke: '#27584D'
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: counters.remotes
                    })
                ]
            }),
            !!hostPlatform && /*#__PURE__*/ _jsxs("div", {
                className: cn(itemClass, 'cursor-not-allowed'),
                children: [
                    /*#__PURE__*/ _jsx(Cloud, {
                        className: "h-4 w-4",
                        style: {
                            stroke: '#27584D'
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: hostPlatform
                    })
                ]
            })
        ]
    });
}
export { ItemCounter };
